import { Navigation, Swiper } from 'swiper';
// eslint-disable-next-line import/extensions
import { breakpoints } from '../../../resources/scripts/config/breakpoints.js';

const swiperElementClass = '.calendar__list';

function updateTabIndexes(slider) {
  slider.slides.forEach((slide, index) => {
    const tabIndexValue = index === slider.activeIndex ? 0 : -1;
    slide.querySelectorAll('button').forEach((button) => {
      // eslint-disable-next-line no-param-reassign
      button.tabIndex = tabIndexValue;
    });
  });
}

function addEventsToSlide(slider) {
  slider.slides.forEach((slide, index) => {
    slide.addEventListener('focusin', () => {
      slider.slideTo(index, 0, false);
    });
  });

  updateTabIndexes(slider);

  slider.on('slideChange', updateTabIndexes.bind(null, slider));
}

function noteKeyDown(element) {
  element.addEventListener('keydown', (event) => {
    const code = (event.keyCode ? event.keyCode : event.which);
    if (code === 13 || code === 32) {
      element.setAttribute('keypress', true);
    }
  });
}

function initSlider(container) {
  const swiperElement = container.closest(swiperElementClass);
  const swiperContainer = container.closest('.calendar__content');
  const sliderWrapper = container.closest('.calendar');
  const prevButton = sliderWrapper.querySelector('.calendar__navigation-btn--prev');
  const nextButton = sliderWrapper.querySelector('.calendar__navigation-btn--next');

  let headerHeight = 100;
  if (window.innerWidth < breakpoints.md) {
    headerHeight = 150;
  }

  noteKeyDown(prevButton);
  noteKeyDown(nextButton);

  // eslint-disable-next-line no-new
  new Swiper(container, {
    slidesPerView: 1,
    modules: [Navigation],
    autoHeight: true,
    navigation: {
      nextEl: nextButton,
      prevEl: prevButton,
      disabledClass: 'calendar__navigation-btn--disabled',
    },
    on: {
      init() {
        addEventsToSlide(this);
      },
      slideChange() {
        const swiperElementRect = swiperElement.getBoundingClientRect();
        const offsetTop = swiperElementRect.top + window.scrollY - headerHeight;

        window.scrollTo({
          top: offsetTop,
        });

        closeAllPopups(); // eslint-disable-line no-use-before-define
      },
      slideChangeTransitionEnd() {
        if (window.innerWidth > breakpoints.lg) {
          if (swiperContainer.querySelectorAll('.calendar__navigation-btn[keypress="true"]').length > 0) {
            swiperContainer.querySelectorAll('.calendar__navigation-btn').forEach((el) => {
              if (!el.classList.contains('calendar__navigation-btn--disabled')) {
                el.focus();
              }
            });

            swiperContainer.querySelectorAll('.calendar__navigation-btn[keypress="true"]').forEach((el) => {
              el.removeAttribute('keypress');
            });
          }
        }
      },
    },
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const initAllSliders = () => {
    const sliderContainers = document.querySelectorAll(swiperElementClass);
    sliderContainers.forEach((el) => {
      initSlider(el);
    });
  };

  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds/calendar', () => {
      initAllSliders();
    });
  } else {
    initAllSliders();
  }
});

const calendarTitleElements = document.querySelectorAll('[data-calendar-title]');
const calendarPopupElements = document.querySelectorAll('[data-calendar-popup]');
const calendarPopupCloseElements = document.querySelectorAll('[data-calendar-popup-close]');

const tabIndex = document.querySelectorAll('button, a, input, select');
const tabIndexMenu = document.querySelectorAll('.performer button, .performer a');

const calendarTitleSwitchElements = document.querySelectorAll('.calendar__info-switch');
const calendarInfoElements = document.querySelectorAll('.calendar__info');

let openedPopupIndex = -1;
let trapFocusHandler = null;

function closeAllPopups() {
  if (openedPopupIndex !== -1) {
    const popup = calendarPopupElements[openedPopupIndex];
    popup.classList.add('performer--hidden');
    calendarTitleSwitchElements[openedPopupIndex].classList.remove('calendar__info-switch--open');

    openedPopupIndex = -1;

    tabIndex.forEach((el) => {
      el.removeAttribute('tabindex');
    });

    document.querySelectorAll('.swiper-slide:not(.swiper-slide-active) [data-calendar-title]').forEach((slideTitle) => {
      slideTitle.setAttribute('tabindex', -1);
    });

    if (trapFocusHandler) {
      popup.removeEventListener('keydown', trapFocusHandler);
      trapFocusHandler = null;
    }
    /* eslint-disable no-use-before-define */
    if (lastFocusedElement) {
      lastFocusedElement.focus();
      lastFocusedElement = null;
    }
    /* eslint-enable no-use-before-define */
  }
}

calendarInfoElements.forEach((element) => {
  if (!element.querySelector('[data-calendar-popup]')) {
    const button = element.querySelector('.calendar__info-item');
    button.classList.add('calendar__info-item--disabled');

    const div = document.createElement('div');
    div.className = button.className;
    div.innerHTML = button.innerHTML;

    Array.from(button.attributes).forEach((attr) => {
      div.setAttribute(attr.name, attr.value);
    });

    button.parentNode.replaceChild(div, button);
  }
});

let lastFocusedElement = null;

calendarTitleElements.forEach((element, index) => {
  element.addEventListener('click', () => {
    if (openedPopupIndex === index) {
      closeAllPopups();
    } else {
      closeAllPopups();

      lastFocusedElement = element;

      calendarPopupElements[index].classList.remove('performer--hidden');
      openedPopupIndex = index;

      tabIndex.forEach((el) => {
        el.setAttribute('tabindex', -1);
      });

      tabIndexMenu.forEach((el) => {
        el.removeAttribute('tabindex');
      });

      const content = calendarPopupElements[index].closest('.calendar__content');
      const list = calendarPopupElements[index].closest('.calendar__list');
      const activeElement = calendarPopupElements[index];

      const offsetBottomEl = activeElement.offsetTop + activeElement.offsetHeight;

      if (offsetBottomEl > list.offsetHeight) {
        const diffElAndList = offsetBottomEl - list.offsetHeight;
        const diffListAndContent = content.offsetHeight - (list.offsetTop + list.offsetHeight);

        if (diffListAndContent < diffElAndList) {
          activeElement.style.bottom = `-${diffListAndContent}px`;
        }
      }

      calendarTitleSwitchElements[openedPopupIndex].classList.add('calendar__info-switch--open');

      calendarPopupElements[index].querySelector('[data-calendar-popup-close]').focus();
      trapFocus(calendarPopupElements[index]); // eslint-disable-line no-use-before-define
    }
  });
});

document.addEventListener('click', (event) => {
  if (!event.target.closest('[data-calendar-title], [data-calendar-popup]')) {
    closeAllPopups();
  }
});

let isMouseDown = true;

document.addEventListener('mousedown', () => {
  isMouseDown = true;
});

const performerButtons = document.querySelectorAll('.calendar__list button');

performerButtons.forEach((button) => {
  button.addEventListener('focus', () => {
    if (isMouseDown) {
      button.classList.add('performer__no-focus-visible');
    }
  });

  button.addEventListener('blur', () => {
    button.classList.remove('performer__no-focus-visible');
  });
});

document.addEventListener('keydown', (event) => {
  isMouseDown = false;
  if (event.key === 'Escape') {
    closeAllPopups();
  }
});

calendarPopupCloseElements.forEach((element) => {
  element.addEventListener('click', () => {
    closeAllPopups();
  });
});

function trapFocus(popup) {
  const focusableElements = popup.querySelectorAll('button, [href]');
  const firstElement = focusableElements[0];
  const lastElement = focusableElements[focusableElements.length - 1];

  trapFocusHandler = (event) => {
    const isTabPressed = event.key === 'Tab';

    if (!isTabPressed) return;

    if (event.shiftKey) {
      if (document.activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      }
    } else if (document.activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  };

  popup.addEventListener('keydown', trapFocusHandler);
}
